module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-reporting-action-buttons"
  }, [(_vm.item) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-reporting',
        params: {
          id: _vm.entity.id
        }
      }
    }
  }, [_vm._v("Edit")])], 1), _c('li', [(_vm.entity.status === 'PENDING_REVIEW' || _vm.entity.status === 'CONFIRMED') ? _c('a', {
    on: {
      "click": _vm.resolve
    }
  }, [_vm._v("Resolve")]) : _vm._e()]), _c('li', [(_vm.entity.status === 'PENDING_REVIEW') ? _c('a', {
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Confirm")]) : _vm._e()]), _c('li', [(_vm.entity.status === 'PENDING_REVIEW') ? _c('a', {
    on: {
      "click": _vm.voided
    }
  }, [_vm._v("Void")]) : _vm._e()])])])]) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [(_vm.entity.status === 'PENDING_REVIEW' || _vm.entity.status === 'CONFIRMED') ? _c('button', {
    staticClass: "button success",
    on: {
      "click": _vm.resolve
    }
  }, [_vm._v("Resolve")]) : _vm._e(), (_vm.entity.status === 'PENDING_REVIEW') ? _c('button', {
    staticClass: "button warning",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Confirm")]) : _vm._e(), (_vm.entity.status !== 'VOIDED') ? _c('button', {
    staticClass: "button alert",
    on: {
      "click": _vm.voided
    }
  }, [_vm._v("Void")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38eb4539!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ReportingActionButtons.vue
// module id = 2416
// module chunks = 1